import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import '@umd-dit/react-auth/style.css';

// Define OIDC web component
import '@umd-dit/react-auth';

// Debug log to check environment variables
console.log('[DEBUG] Environment Variables:', {
  apiUrl: import.meta.env.VITE_API_URL,
  usersUrl: import.meta.env.VITE_USERS_URL,
  oidcAuthority: import.meta.env.VITE_OIDC_AUTHORITY,
  oidcClientId: import.meta.env.VITE_OIDC_CLIENT_ID,
  oidcDevmode: import.meta.env.VITE_OIDC_DEVMODE,
  mode: import.meta.env.MODE,
  base: import.meta.env.BASE_URL
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);